import Modifier from 'ember-modifier';
import { Chart } from 'chart.js';
import { registerDestructor } from '@ember/destroyable';

const cleanup = (instance) => {
  instance.chart?.destroy();
};

class EmberChartModifier extends Modifier {
  chart = null;

  constructor() {
    super(...arguments);
    registerDestructor(this, cleanup);
  }

  modify(element, _, { labels, datasets, type, options, animate = true, plugins = [] }) {
    if (!this.chart) {
      this.chart = new Chart(element, { data: { labels, datasets }, type, options, plugins });
      return;
    }

    const { chart } = this;
    chart.data.labels = labels;
    chart.data.datasets = datasets;
    chart.options = options;

    if (animate) {
      chart.update();
    } else {
      chart.update('none');
    }
  }
}

export default EmberChartModifier;
